import React from 'react'
import styled from 'styled-components'
import { Box } from '../../new/core-components/box'

import { Text } from '../../new/core-components/text'
import { ThemeColors } from '../../new/theme/colors'
import { Props as ButtonProps } from './Button'
import { ButtonStyled } from './ButtonStyled'

const StyledText = styled(Text)<{
  textColor: string
  underlineColor?: ThemeColors
}>`
  color: ${({ theme, textColor }) => {
    return theme.colors[textColor as ThemeColors] ?? textColor
  }};
  box-shadow: ${({ theme, underlineColor, textColor }) => {
    if (underlineColor) {
      return `inset 0px -2px 0px ${theme.colors[underlineColor]}`
    }
    if (textColor?.includes('major')) {
      return theme.shadows['border/action-underline-major']
    }
    if (textColor?.includes('minor')) {
      return theme.shadows['border/action-underline-minor']
    }
    if (textColor?.includes('moderate')) {
      return theme.shadows['border/action-underline-moderate']
    }
    if (textColor?.includes('inform')) {
      return theme.shadows['border/action-underline-inform']
    }
    if (textColor?.includes('caution')) {
      return theme.shadows['border/action-underline-caution']
    }
    if (textColor?.includes('warning')) {
      return theme.shadows['border/action-underline-warning']
    }

    // Support for hex colors
    if (textColor.includes('#')) {
      return `inset 0px -2px 0px ${textColor}1F`
    }
    // Support old usage until all instances are updated
    const lightColor = textColor?.replace(/\d+$/, '12')
    if (lightColor) {
      return `inset 0px -2px 0px ${theme.colors[lightColor as ThemeColors]}`
    }
  }};
`

type Props = ButtonProps & {
  DISCOURAGED_hexColor?: string // Sometimes we choose color from color picker
  underlineColor?: ThemeColors
}

/** @deprecated - Use LinkButton component from `@chilipiper/design-system/src/new` instead */
export const LinkButton = ({
  children,
  disabled,
  color = 'text/action-major',
  underlineColor,
  htmlType,
  endIcon,
  startIcon,
  DISCOURAGED_hexColor,
  ...others
}: Props) => {
  return (
    <ButtonStyled
      m={0}
      p={0}
      bg='transparent'
      color={DISCOURAGED_hexColor || color}
      disabled={disabled}
      type={htmlType}
      lineHeight='14px'
      {...others}
    >
      <StyledText
        pb='2px'
        fontWeight={600}
        textColor={DISCOURAGED_hexColor || color}
        underlineColor={underlineColor}
        display='flex'
      >
        {startIcon && <Box mr={2}>{startIcon}</Box>}
        {children}
        {endIcon && <Box ml={2}>{endIcon}</Box>}
      </StyledText>
    </ButtonStyled>
  )
}
